import http from './http';

// Endpoints B1_02 (contrat C5), gated admin (router suadmin) :
//   GET /api/suadmin/deactivation-surveys/aggregate?from=&to=   → { by_reason, by_version, by_locale, total }
//   GET /api/suadmin/deactivation-surveys/free-text?from=&to=&page=  → { items, page, total } (verbatims sensibles, 50/page)
// http.js préfixe déjà /api et ajoute le header Authorization (gc_token). Signature réelle de http.get =
// un seul argument `path` (pas d'objet { params }) → query string construite à la main, conditionnelle
// (pas de `from=undefined`) + encodeURIComponent. Calque funnelService.js (B3_01).
const buildQuery = (parts) => {
  const qs = parts.filter(Boolean).join('&');
  return qs ? `?${qs}` : '';
};

const getAggregate = (from, to) => {
  const params = [];
  if (from) params.push(`from=${encodeURIComponent(from)}`);
  if (to) params.push(`to=${encodeURIComponent(to)}`);
  return http.get(`/suadmin/deactivation-surveys/aggregate${buildQuery(params)}`);
};

const getFreeText = (from, to, page) => {
  const params = [];
  if (from) params.push(`from=${encodeURIComponent(from)}`);
  if (to) params.push(`to=${encodeURIComponent(to)}`);
  if (page) params.push(`page=${encodeURIComponent(page)}`);
  return http.get(`/suadmin/deactivation-surveys/free-text${buildQuery(params)}`);
};

export default { getAggregate, getFreeText };
export { getAggregate, getFreeText };
